export default __webpack_public_path__ + "static/media/wave-tablet.af2ed23a.svg";